import styles from './styles.module.scss';
import { PreviewDetailSection } from './PreviewDetailSection';
import { Fragment } from 'react';

import { PreviewFormActions } from './PreviewFormActions';

export const PreviewFormHeader = ({ pdfDocAndPageRefs, ...restProps }) => {
  return (
    <Fragment>
      <div className={styles.previewFormHeader}>
        <div className={styles.previewFormHeaderSection}>
          <PreviewDetailSection {...restProps} />
          <PreviewFormActions {...restProps} pdfDocAndPageRefs={pdfDocAndPageRefs} />
        </div>
      </div>
    </Fragment>
  );
};
